import {DirectiveBinding} from "vue/types/options";
import {VNode} from "vue";

export default {
  install: (Vue: any, options: any) => {
    Vue.directive('acl', (element: HTMLElement, bindings: DirectiveBinding, vNode: VNode) => {
      if (!options.handler(bindings.value, bindings.arg, bindings.modifiers)) {
        vNode.elm = document.createComment(' ')
        vNode.text = ' '
        vNode.isComment = true
        vNode.context = undefined
        vNode.tag = undefined
        vNode.data!.directives = undefined
      }
    })

    Vue.prototype.$acl = options.handler
  }
}

